const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * FAQS EVENTS                                                                *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.faqsItemclicked, (payload) => {
    pushEvent(
      createCustomEventGA4('faq', [
        ['action', 'click'],
        ['item', payload.item],
        ['option', payload.option],
      ])
    );
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
